import React, { Component } from 'react';
import { Status } from 'common/utils/constants';
import DropModal from 'components/shared/DropModal/DropModal';
import CommentBlock from 'components/features/Comments/CommentBlock/CommentBlock';
import { connect } from 'react-redux';
import { addComment, deleteComment, getAllComments } from 'apis/Comments';
import { updateStatus } from 'redux/actions';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import { IconAndText } from 'components/shared/SvgAF/SvgAF';
import classnames from 'classnames';
import './CommentsWidget.css';
import { IconLoader } from 'common/IconLoader';

import moment from 'moment';
import { PerfectScrollbar } from 'components/shared/ReactPerfectScrollbar';

class CommentsWidget extends Component {
  state = {
    inputFocused: false,
    isBlurred: false,
    shouldInitComments: true,
    forceClose: false,
    comments: [
      // {
      //   "user": "test2",
      //   "text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi ultrices urna neque, sed convallis enim dictum id. In eget semper nunc. Nunc suscipit aliquam tortor ut lobortis. Donec aliquam, tortor eu posuere fermentum, ex tellus rhoncus magna, eu porttitor est mi et neque. Cras sapien leo, consectetur sed mattis blandit, congue nec tortor. Aliquam cursus mi libero, non vehicula lectus auctor quis. Fusce purus nunc, condimentum in est suscipit, cursus scelerisque lectus. Phasellus venenatis, dolor et lacinia interdum, dui dui volutpat ipsum, id pretium nulla nulla vel mi. Proin et lacus a leo varius interdum ac at magna. Nunc sed pretium nisi. Vestibulum non maximus nisi. In eget lacus dui. Fusce porta bibendum lacus. Vivamus sagittis quis urna blandit vestibulum. Sed pretium lacus et ligula varius, in dignissim nunc gravida.",
      //   "recordedTime": "2022-06-15T13:46:30.0000690Z",
      //   "comment_id": "0b569960-1234-11ea-b48e-615c4a139178"
      // },
      // {
      //   "user": "test2",
      //   "text": "test text2",
      //   "recordedTime": "2022-06-15T13:47:30.0000690Z",
      //   "comment_id": "0b569960-4321-11ea-b48e-615c4a139178"
      // },
      // {
      //   "user": "test2",
      //   "text": "test text3",
      //   "recordedTime": "2022-06-15T13:48:30.0000690Z",
      //   "comment_id": "0b569960-2222-11ea-b48e-615c4a139178"
      // },
      // {
      //   "user": "test2",
      //   "text": "test text4",
      //   "recordedTime": "2022-06-15T13:49:30.0000690Z",
      //   "comment_id": "0b569960-3333-11ea-b48e-615c4a139178"
      // }
    ]
  };

  initComments(openState) {
    if (this && this.commentsInputDiv && openState) {
      this.openState = openState;
      this.commentsInputDiv.current.innerHTML = '';
      this.setState({ currentText: '' });

      if (this.state.shouldInitComments && this.props.selectedDevice) {
        this.props.dispatch(updateStatus('getAllComments-' + this.props.selectedDevice.id, Status.PENDING));
        getAllComments(this.props.selectedDevice.id)
          .then((result) => {
            if (result.comments) {
              this.props.dispatch(updateStatus('getAllComments-' + this.props.selectedDevice.id, Status.SUCCESS));

              let initialComments = [];
              result.comments.forEach((comment) => {
                initialComments.push(comment);
              });
              this.setState({ comments: initialComments, shouldInitComments: false });
            }
          })
          .catch((e) => {
            this.props.dispatch(updateStatus('getAllComments-' + this.props.selectedDevice.id, Status.FAILURE));
          });

        this.setState({ shouldInitComments: false }, () => {
          console.log('comments init ready');
        });
      }
    }

    if (this && this.commentsInputDiv && !openState) {
      this.openState = openState;
    }
  }

  doAddComment() {
    this.props.dispatch(updateStatus('addComment-' + this.props.selectedDevice.id, Status.PENDING));
    let recordedTime = moment().toISOString();
    addComment(this.props.selectedDevice.id, this.props.user.nickname, this.state.currentText, recordedTime)
      .then((result) => {
        if (result.status === 'add success') {
          //this.currentText = "";
          this.commentsInputDiv.current.innerHTML = '';
          this.props.dispatch(updateStatus('addComment-' + this.props.selectedDevice.id, Status.SUCCESS));
          let test = this.state.comments;
          test.push({
            user: this.props.user.nickname,
            text: this.state.currentText,
            recordedTime: recordedTime,
            comment_id: result.comment_id
          });
          this.setState({ comments: test }, () => this.setState({ currentText: '' }));
        }
      })
      .catch((e) => {
        this.props.dispatch(updateStatus('addComment-' + this.props.selectedDevice.id, Status.FAILURE));
      });
  }

  doDeleteComment(targetCommentID) {
    this.props.dispatch(updateStatus('deleteComment-' + this.props.selectedDevice.id, Status.PENDING));
    deleteComment(this.props.selectedDevice.id, targetCommentID)
      .then((result) => {
        if (result.status === 'delete success') {
          this.props.dispatch(updateStatus('deleteComment-' + this.props.selectedDevice.id, Status.SUCCESS));
          let test = this.state.comments;
          test = test.filter((x) => x.comment_id !== targetCommentID);
          this.setState({ comments: test });
        }
      })
      .catch((e) => {
        this.props.dispatch(updateStatus('deleteComment-' + this.props.selectedDevice.id, Status.FAILURE));
      });
  }

  componentDidUpdate() {
    // if (this.state.shouldInitComments) {
    //   this.props.dispatch(updateStatus("getAllComments-"+this.props.selectedDevice.id, Status.PENDING));
    //   getAllComments(this.props.selectedDevice.id).then((result) => {
    //     if (result.comments)
    //     {
    //       this.props.dispatch(updateStatus("getAllComments-"+this.props.selectedDevice.id, Status.SUCCESS));

    //       let initialComments= [];
    //       result.comments.forEach(comment => {
    //         initialComments.push(comment);
    //       })
    //       this.setState({comments: initialComments, shouldInitComments: false});
    //     }
    //   }).catch(e => {
    //     this.props.dispatch(updateStatus("getAllComments-"+this.props.selectedDevice.id, Status.FAILURE));
    //   })
    // }

    if (this.state.forceClose && this.openState) {
      this.setState({ forceClose: false });
    }
  }

  // test() {
  //   this.state.forceClose && this.setState({forceClose: false})
  // }

  constructor(props) {
    super(props);
    this.commentsInputDiv = React.createRef();
    this.currentText = '';
    this.openState = false;
  }

  render() {
    let dropModalButtonContent = (
      <div className="dropModalButtonContent">
        <SvgAF img={IconLoader.icon_device_note} hover={IconLoader.icon_device_note_hover} />
      </div>
    );

    let modalName = 'comments_' + (this.props.selectedDevice ? this.props.selectedDevice.id : 0);

    let modalHeightOffset = 64 + 64;
    this.state.currentText !== '' && (modalHeightOffset -= 24);

    let commentsLengthIndex = this.state.comments.length - 1;

    return (
      <div className="commentsWidgetContainer">
        <DropModal
          title={dropModalButtonContent}
          name={modalName}
          maxHeight={window.innerHeight - modalHeightOffset + 'px'}
          isOpenListener={(openState) => {
            this.initComments(openState);
          }}
          forceClose={this.state.forceClose}
        >
          <div className="commentsPopout" onBlur={this.test} tabIndex="1">
            <div className="commentsPopoutHeader">
              <IconAndText img={IconLoader.icon_device_note} hoverImg={IconLoader.icon_device_note} text={'Comments'} />
              <div className="commentsPopoutCloseButton">
                <SvgAF
                  img={IconLoader.icon_device_close}
                  hover={IconLoader.icon_device_close_hover}
                  onClick={() => this.state.forceClose === false && this.setState({ forceClose: true })}
                />
              </div>
            </div>
            <div className="commentsPopoutContent">
              <div className={classnames('commentsInputContainer', { focused: this.state.inputFocused })}>
                <PerfectScrollbar>
                  <div className="commentsScrollBarWrapper">
                    <div
                      ref={this.commentsInputDiv}
                      className="commentsInput"
                      data-placeholder="Type something..."
                      contentEditable="true"
                      onFocus={() => !this.state.inputFocused && this.setState({ inputFocused: true })}
                      onBlur={() => this.state.inputFocused && this.setState({ inputFocused: false })}
                      onInput={(evt) => this.setState({ currentText: evt.currentTarget.textContent })}
                    />
                  </div>
                </PerfectScrollbar>
                {this.state.currentText !== '' && (
                  <div className="commentsInputOptionsRow">
                    <div className="addCommentButton" onClick={() => this.doAddComment()}>
                      Add
                    </div>
                  </div>
                )}
              </div>

              <PerfectScrollbar>
                {/* offset fixed parent sizing and margins */}
                <div
                  className="commentsSection"
                  style={{ maxHeight: window.innerHeight - (42 + 34 + 16 + 12 + 64 + 64 + 12) }}
                >
                  {this.state.comments.map((comment, index) => (
                    <CommentBlock
                      commentData={this.state.comments[commentsLengthIndex - index]}
                      maxTextHeight={100}
                      deleteComment={(targetCommentID) => this.doDeleteComment(targetCommentID)}
                    />
                  ))}
                </div>
              </PerfectScrollbar>
            </div>
          </div>
        </DropModal>
      </div>
    );
  }
}

export default connect((store) => {
  return {
    selectedDevice: store.ui.singleDevicePage.selectedDevice,
    user: store.data.user
  };
})(CommentsWidget);
